import React, { useEffect, useRef, useState } from "react";
import { useLocation, useOutlet ,useOutletContext,useNavigate} from "react-router-dom";

import IsMntnInqApi from "Apis/IsMntnInqApi";

import GameMainEventBnrUi from "./EventBnrSlide";
import GameHdrUi from "./GameHdrUi";
import GameCtntTop5LstUi from "./GameCtntTop5LstUi";
import GameGuideSlideUi from "./GameGuideSlide";
import GameMainPageApi from "Apis/GameMainPageApi";
import UseLangLstQuery from "Apis/LangTxtInqApi";
import { Helmet } from "react-helmet-async";
import { Margin } from "@mui/icons-material";
import MainGuideSlide from "./MainGuideSlide";
import { isMobile } from "react-device-detect";

interface GameMainPageInfo {
    gameNm?: string;
    // ...필요한 속성 추가
}
const GamePageMainUi = () => {
        useEffect(() => {
            const setHeights = () => {
                const video = document.querySelector('.gamePageVideoBg') as HTMLVideoElement;
                const imgWrap = document.querySelector('.absoluteImgWrap') as HTMLElement;
                const noticeContainer = document.querySelector('.gamePageNoticeContainer') as HTMLElement;
                if (window.innerWidth <= 1400) {
                    // video 최소 높이 = noticeContainer 높이 + 100
                    if (video && noticeContainer) {
                        const minHeight = noticeContainer.clientHeight + 100;
                        video.style.minHeight = `${minHeight}px`;
                    }
                    // absoluteImgWrap 높이 = video 높이
                    if (video && imgWrap) {
                        imgWrap.style.height = `${video.clientHeight}px`;
                    }
                } else {
                    if (video) video.style.minHeight = '';
                    if (imgWrap) imgWrap.style.height = '';
                }
            };
            window.addEventListener('resize', setHeights);
            setHeights();
            // video가 로드될 때도 높이 반영
            const video = document.querySelector('.gamePageVideoBg') as HTMLVideoElement;
            if (video) {
                video.addEventListener('loadeddata', setHeights);
                video.addEventListener('canplay', setHeights);
            }
            return () => {
                window.removeEventListener('resize', setHeights);
                if (video) {
                    video.removeEventListener('loadeddata', setHeights);
                    video.removeEventListener('canplay', setHeights);
                }
            };
        }, []);
    const location= useLocation();  
    const serchParamsFunc = () => {
        return new URLSearchParams(location.search);
    }
    let query =serchParamsFunc();
    let getGameSvcCd = query.get("gameSvcCd");
    let {gameMainPageData, langData, mntnData, tstrData}:any = useOutletContext();
    const [gameSvcCd,setGameSvcCd] = useState(getGameSvcCd);
    const [isPortrait, setIsPortrait] = useState(window.innerHeight > window.innerWidth);
    const [isMobileLayout, setIsMobileLayout] = useState(window.innerWidth <= 1024);
    const contentColumnsRef = useRef<HTMLDivElement | null>(null);
    const fixedContentHeightRef = useRef(0);
    const bgVideoRef = useRef<HTMLVideoElement | null>(null);

    const resumeBgVideo = () => {
        const video = bgVideoRef.current;
        if (!video) return;
        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
        }
    };
    
    useEffect(() => {
        const handleResize = () => {
            setIsPortrait(window.innerHeight > window.innerWidth);
            setIsMobileLayout(window.innerWidth <= 1024);
        };
        
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const handleVisibility = () => {
            if (!document.hidden) {
                resumeBgVideo();
            }
        };

        document.addEventListener('visibilitychange', handleVisibility);
        return () => document.removeEventListener('visibilitychange', handleVisibility);
    }, []);

    useEffect(() => {
        const syncContentHeight = () => {
            const wrap = contentColumnsRef.current;
            if (!wrap) return;

            const columns = Array.from(wrap.children)
                .filter((el) => (el as HTMLElement).classList.contains('ctntLstWrap')) as HTMLElement[];

            if (columns.length < 2) return;

            if(window.innerWidth <= 1024) {
                columns.forEach((el) => {
                    el.style.height = 'auto';
                });
                fixedContentHeightRef.current = 0;
                return;
            }

            columns.forEach((el) => {
                el.style.height = 'auto';
            });

            const maxHeight = Math.max(...columns.map((el) => el.getBoundingClientRect().height));
            const fixedHeight = Math.max(fixedContentHeightRef.current, Math.ceil(maxHeight));
            fixedContentHeightRef.current = fixedHeight;

            columns.forEach((el) => {
                el.style.height = `${fixedHeight}px`;
            });
        };

        const syncAfterRender = () => {
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    syncContentHeight();
                });
            });
        };

        syncContentHeight();
        syncAfterRender();
        window.addEventListener('resize', syncContentHeight);

        let observer: ResizeObserver | null = null;
        if (typeof ResizeObserver !== 'undefined' && contentColumnsRef.current) {
            observer = new ResizeObserver(() => {
                syncContentHeight();
            });
            Array.from(contentColumnsRef.current.children).forEach((el) => {
                observer?.observe(el);
            });
        }

        const mediaTargets = contentColumnsRef.current
            ? Array.from(contentColumnsRef.current.querySelectorAll('img, video')) as Array<HTMLImageElement | HTMLVideoElement>
            : [];

        const mediaEvents: Array<[keyof GlobalEventHandlersEventMap, EventListener]> = [
            ['load', syncAfterRender],
            ['error', syncAfterRender],
            ['loadedmetadata', syncAfterRender],
            ['loadeddata', syncAfterRender],
            ['canplay', syncAfterRender],
        ];

        mediaTargets.forEach((el) => {
            mediaEvents.forEach(([eventName, handler]) => {
                el.addEventListener(eventName, handler);
            });
        });

        return () => {
            window.removeEventListener('resize', syncContentHeight);
            observer?.disconnect();
            mediaTargets.forEach((el) => {
                mediaEvents.forEach(([eventName, handler]) => {
                    el.removeEventListener(eventName, handler);
                });
            });
        };
    }, [gameMainPageData, langData, gameSvcCd]);

    // const navigate = useNavigate();
    // useEffect(() => {
    //     navigate('/preregister?gameSvcCd=KBBO', { replace: true });
    // }, [navigate]);
    return(
        <>
            <Helmet>
                <title> {`${gameMainPageData&&gameMainPageData.gameNm}`}</title>
            </Helmet>
            <div className="gamePageWrap">
                <GameMainEventBnrUi gameSvcCd={gameSvcCd} gameMainPageInfo={gameMainPageData}/>
                <div className="ctntLstWrap mainGuideSectionWrap">
                    <MainGuideSlide gameSvcCd={gameSvcCd} gameMainPageInfo={gameMainPageData}/>
                </div>
                <div className="gamectntLstWrap">           
                    <img
                        className="noticeBrickFx"
                        src={process.env.PUBLIC_URL + (isMobile || isMobileLayout ? '/images/Mainpage/noticebrick_mo.png' : '/images/Mainpage/noticebrick.png')}
                        alt="Notice Brick"
                    />
                    <div ref={contentColumnsRef} className="container1400 dFlex jcCenter alignCenter gamePageNoticeContainer">
                        <GameCtntTop5LstUi gameSvcCd={gameSvcCd} ctntCtgrCd="PNOT" ctntCtgrCdName={"NOTICE"}LstType={"top5"}></GameCtntTop5LstUi>
                    </div>
                </div>
                <div className="GameGuideSlideBg gamePageGameGuideSlideBg">
                    <GameGuideSlideUi gameSvcCd={gameSvcCd} gameMainPageInfo={gameMainPageData}/>
                </div>
            </div>
        </>
    )
}
export default GamePageMainUi;
